import React, { useMemo, useState } from 'react';
import { MenuItem } from '../../../models/MenuItem';
import { cleanLink } from '../../../shared/cleanLink';
import { useMainMenuData } from './useMainMenuData';
import { MainMenuSubMenu } from './MainMenuSubMenu';
import './AccordionMenu.scss';

interface Props {
    footer?: boolean;
    setSidebarOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}

export const AccordionMenu = ({ footer, setSidebarOpen }: Props) => {
    const { parentItems, footerSitesItems } = useMainMenuData();
    const [expandedTitle, setExpandedTitle] = useState<string | null>(null);

    const items: MenuItem[] = useMemo(() => {
        const nodes = [...parentItems];
        if (footer) {
            nodes.push({
                id: `footer-sites-cat`,
                url: ``,
                title: `Spectrum Sites`,
                enabled: true,
                weight: `100`,
                menu_name: ``,
                childrenMenuItems: footerSitesItems,
            });
        }
        return nodes;
    }, [parentItems, footer, footerSitesItems]);

    const toggleExpanded = (title: string) => {
        setExpandedTitle((prev) => (prev === title ? null : title));
    };

    return (
        <nav
            className={`accordion-menu${footer ? ` accordion-menu--footer` : ``}`}
        >
            {items.map((item) => {
                const titleId = `menu-${footer ? `footer` : ``}-${cleanLink(item.title)}`;
                const isExpanded = expandedTitle === item.title;
                const actionName = isExpanded ? `Collapse` : `Expand`;

                return (
                    <section
                        className={isExpanded ? `expanded` : ``}
                        key={item.id}
                    >
                        <div className="category">
                            <button
                                aria-label={`${actionName} ${item.title} category`}
                                id={item.title}
                                className="category"
                                onClick={() => toggleExpanded(item.title)}
                                aria-expanded={isExpanded}
                                aria-controls={titleId}
                                aria-haspopup="true"
                            >
                                {item.title}
                            </button>
                        </div>
                        <MainMenuSubMenu
                            items={item.childrenMenuItems}
                            title={item.title}
                            titleId={titleId}
                            footer={footer}
                            ariaHidden={!isExpanded}
                            setSidebarOpen={setSidebarOpen}
                            handleClose={() => setExpandedTitle(null)}
                            handleKeyDown={(e) => {
                                if (e.key === `Escape`) {
                                    setExpandedTitle(null);
                                    document
                                        .getElementById(item.title)
                                        ?.focus();
                                }
                            }}
                        />
                    </section>
                );
            })}
        </nav>
    );
};
